// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"64":"ee3e576c","998":"7cc15981"}[chunkId] + ".js";
};